import { testkit as corePopoverDriverFactory } from '../internal/WixUiCoreComponents/components/CorePopover/CorePopover.uni.driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const popoverDriverFactory = (base: UniDriver, body: UniDriver) => {
  return corePopoverDriverFactory(base, body);
};
